import { formatEmployeeId } from "./idFormat";

const QR_API_BASE = "https://api.qrserver.com/v1/create-qr-code/";

export const buildEmployeeQrText = (employee = {}) => {
  const employeeId = formatEmployeeId(employee);
  const name = employee?.fullName || "-";
  const role = employee?.designation || employee?.employeeRole?.name || employee?.role || "Employee";
  const status = employee?.approved === false ? "Inactive" : "Active";
  const mobile = employee?.mobile || "-";

  return [
    "Lotus Rice Mill Pvt. Ltd.",
    `Employee ID: ${employeeId}`,
    `Name: ${name}`,
    `Role: ${role}`,
    `Mobile: ${mobile}`,
    `Status: ${status}`,
  ].join("\n");
};

export const buildEmployeeQrUrl = (employee = {}, size = 120) => {
  const qrData = buildEmployeeQrText(employee);
  const px = Math.max(80, Math.min(240, Number(size) || 120));
  return `${QR_API_BASE}?size=${px}x${px}&format=png&margin=1&data=${encodeURIComponent(qrData)}`;
};
